import template from './contact_request_print.html';
import controller from './contact_request_print.controller';
import './contact_request_print.scss';

let printComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default printComponent;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/contact_request/print/contact_request_print.component.js